<template>
  <div class="py-3">
    <v-card flat class="rounded-lg pa-6">
      <div>
        <div class="d-flex align-center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="black"
                v-bind="attrs"
                v-on="on"
                class="mr-2"
                @click="$router.go(-1)"
                icon
                ><v-icon>mdi-reply</v-icon></v-btn
              >
            </template>
            <span>Back</span>
          </v-tooltip>
          <h1>Monitoring - {{ dataSet ? dataSet[0].title : "" }}</h1>
        </div>

      </div>
    </v-card>
    <v-card flat class="rounded-lg pa-6 mt-6">
      <div>
        <h4>Event Title</h4>
        <v-text-field
          v-if="dataSet && !loading"
          class="d-flex align-center mt-2 rounded-lg"
          dense
          readonly
          rounded
          filled
          v-model="dataSet[0].title"
          placeholder="Put the title here"
          hide-details
          color="green"
          style="width: 40%"
        ></v-text-field>
        <v-skeleton-loader
          class="mt-2"
          height="30px"
          v-if="loading"
          type="image"
        ></v-skeleton-loader>
      </div>
      <div class="mt-2">
        <h4>Description</h4>
        <v-textarea
          v-if="dataSet && !loading"
          class="my-2 rounded-lg"
          auto-grow
          rows="4"
          placeholder="Put the title here"
          v-model="dataSet[0].description"
          hide-details
          dense
          rounded
          readonly
          filled
        ></v-textarea>
        <v-skeleton-loader
          class="mt-2"
          height="90px"
          v-if="loading"
          type="image"
        ></v-skeleton-loader>
      </div>
      <div class="mt-2">
        <h4>Execution Date</h4>
        <v-menu
          v-model="showPickerStart"
          :close-on-content-click="false"
          v-if="!loading && !dataSetMonitoring"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
          max-width="290px"
          disabled
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="start_date"
              append-icon="mdi-calendar-range"
              readonly
              hide-details
              v-on="on"
              placeholder="Start Event Date"
              class="rounded-lg"
              filled
              style="width: 40%"
              rounded
            ></v-text-field>
          </template>
          <div>
            <v-date-picker
              v-model="start_date"
              @input="closeDateMenu('start')"
            ></v-date-picker>
          </div>
        </v-menu>
        <v-menu
          v-model="showPickerStart"
          :close-on-content-click="false"
          v-if="!loading && dataSetMonitoring"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          disabled
          min-width="290px"
          max-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dataSetMonitoring.monitoring_date"
              append-icon="mdi-calendar-range"
              readonly
              hide-details
              style="width: 40%"
              v-on="on"
              filled
              placeholder="Start Event Date"
              class="rounded-lg"
            ></v-text-field>
          </template>
          <div>
            <v-date-picker
              v-model="dataSetMonitoring.monitoring_date"
              @input="closeDateMenu('start')"
            ></v-date-picker>
          </div>
        </v-menu>
        <v-skeleton-loader
          class="mt-2"
          height="30px"
          v-if="loading"
          type="image"
        ></v-skeleton-loader>
      </div>
      <div class="mt-2">
        <h4>Additional</h4>
        <v-textarea
          v-if="dataSet && !loading && !dataSetMonitoring"
          class="my-2 rounded-lg"
          auto-grow
          rows="4"
          rounded
          readonly
          filled
          placeholder="Put the description here"
          v-model="additional_info"
          hide-details
          dense
        ></v-textarea>
        <v-textarea
          v-if="dataSet && !loading && dataSetMonitoring"
          class="my-2 rounded-lg"
          auto-grow
          rows="4"
          rounded
          readonly
          filled
          placeholder="Put the description here"
          v-model="dataSetMonitoring.additional_info"
          hide-details
          dense
        ></v-textarea>
        <v-skeleton-loader
          class="mt-2"
          height="90px"
          v-if="loading"
          type="image"
        ></v-skeleton-loader>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "monitoringProposalTsa",
  data() {
    return {
      showPickerStart: false,
      start_date: "",
      additional_info: "",
      optStatusInternship: [
        {
          name: "Active",
          val: "aktif",
        },
        {
          name: "Done",
          val: "selesai",
        },
      ],
      loading: true,
      dataSet: null,
      dataSetMonitoring: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    closeDateMenu(type) {
      this.showPickerStart = false;
      if (this.dataSetMonitoring) {
        this.dataSetMonitoring.start_date == ""
          ? this.date.format("dddd, MMMM Do YYYY")
          : "";
      } else {
        this.start_date == "" ? this.date.format("dddd, MMMM Do YYYY") : "";
      }
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `tsa-proposal/admin/register?filter[id]=${this.$route.params.idEventProposal}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.fetchDataMonitoring();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchDataMonitoring() {
      this.loading = true;
      let data = {
        path: `tsa-proposal/admin/monitor?tsa_activity_id=${this.$route.params.idEventProposal}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSetMonitoring = data;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
